<script context="module">
    import { get } from "svelte/store";

    import { isObjectEmpty } from "../../../Utils/utilFunctions.svelte";

    import {
        insuranceFund,
        workersCompensation,
        trafficAccidentAuthorities,
        wcEncounterIdFullDetails,
        tacEncounterIdFullDetails,
    } from "../../../stores";

    import { DirectInsuranceType } from "../../../Utils/utilEnums.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    export const getNameOfInsurer = (encounter = {}) => {
        if (!encounter || isObjectEmpty(encounter)) return "";

        const {
            patient: { insuranceType, insuranceId },
            patientEncounterWorkCoverData,
            patientEncounterTrafficAccidentData,
        } = encounter;

        const insuranceTypeHasFund = [0, 16, 17]; // Private, Work Cover, Traffic Accident

        if (!insuranceTypeHasFund.includes(insuranceType)) return "";

        if (insuranceType == 0) {
            const fundArr = get(insuranceFund);

            const fund = fundArr.find((fund) => fund.id == insuranceId);

            if (!fund) return "";

            return fund.name ?? "";
        }

        if (insuranceType == 16) {
            const targetInsuranceId =
                patientEncounterWorkCoverData?.workCoverAuthority ??
                insuranceId ??
                0;

            if (!targetInsuranceId)
                return patientEncounterWorkCoverData?.employer ?? "";

            const fundArr = get(workersCompensation);

            const fund = fundArr.find((fund) => fund.id == targetInsuranceId);

            if (!fund) return "";

            return fund.name ?? "";
        }

        if (insuranceType == 17) {
            const targetInsuranceId =
                patientEncounterTrafficAccidentData?.trafficAccidentAuthority ??
                insuranceId ??
                0;

            if (!targetInsuranceId) return "";

            const fundArr = get(trafficAccidentAuthorities);

            const fund = fundArr.find((fund) => fund.id == targetInsuranceId);

            if (!fund) return "";

            return fund.name ?? "";
        }

        return "";
    };

    export const getEncounterWithWcAndTacDetails = async (encounters = []) => {
        if (!encounters.length) return [];

        wcEncounterIdFullDetails.set([]);
        tacEncounterIdFullDetails.set([]);

        encounters.map((encounter) => {
            if (
                encounter?.patient?.insuranceType ==
                DirectInsuranceType.WorkersCompensation
            ) {
                const wc = get(wcEncounterIdFullDetails);
                wcEncounterIdFullDetails.set([...wc, encounter.id]);
            }

            if (
                encounter?.patient?.insuranceType ==
                DirectInsuranceType.TrafficAccident
            ) {
                const tac = get(tacEncounterIdFullDetails);
                tacEncounterIdFullDetails.set([...tac, encounter.id]);
            }
        });

        const MAX_BULK_ENCOUNTERS = 5,
            allIds = [
                ...get(wcEncounterIdFullDetails),
                ...get(tacEncounterIdFullDetails),
            ];

        let finished = 0;

        while (finished < allIds.length) {
            let numOfThisBatch = 0,
                promises = [];

            while (numOfThisBatch < MAX_BULK_ENCOUNTERS) {
                const currId = allIds[finished + numOfThisBatch];

                if (!currId) {
                    numOfThisBatch++;
                    continue;
                }

                promises.push(
                    apiMethods.getMethod
                        .getPatientEncounterById(currId)
                        .then((res) => {
                            if (res.id)
                                encounters = encounters.map((enc) => {
                                    if (enc.id == res.id) return res;
                                    return enc;
                                });
                        }),
                );
                numOfThisBatch++;
            }

            await Promise.all(promises);
            finished += promises.length;
        }

        wcEncounterIdFullDetails.set([]);
        tacEncounterIdFullDetails.set([]);

        return encounters;
    };
</script>
